<template>
  <v-app class="purple darken-4">
    <Toast :show="$store.state.alert.show" :msg="$store.state.alert.msg" :color="$store.state.alert.color"
      :position="$store.state.alert.position" />
    <!-- Loading Overlay -->
    <v-overlay :value="$store.state.isLoading" :color="$vuetify.theme.dark ? 'black' : 'white'" opacity="0.8"
      z-index="9999">
      <Loader />
    </v-overlay>
    <div id="tpl-app" class="d-flex mx-auto flex-column">
      <TitleBar :title="$route.name" />
      <v-main class="bt-content pb-12">
        <Navbar />
        <router-view />
        <v-dialog v-model="updateDialog" persistent max-width="290" style="z-index: 9999">
          <v-card>
            <v-card-title class="text-h5"> Update </v-card-title>
            <v-card-text>Update sistem tersedia! Update Sekarang!</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="reloadPage"> Update </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-main>
      <Navigation />
    </div>

    <div class="update-dialog" v-if="prompt">
      <div class="update-dialog__content">
        A new version is found. Refresh to load it?
      </div>
      <div class="update-dialog__actions">
        <button class="update-dialog__button update-dialog__button--confirm" @click="update">
          Update
        </button>
        <button class="update-dialog__button update-dialog__button--cancel" @click="prompt = false">
          Cancel
        </button>
      </div>
    </div>

    <v-dialog v-model="dialogLogout" max-width="420" overlay-opacity="0.4" persistent>
      <v-card elevation="8" class="rounded-lg">
        <v-card-title class="text-h6 font-weight-medium red--text">
          <v-icon color="red darken-2" class="mr-2">mdi-alert-circle-outline</v-icon>
          Sesi Telah Berakhir
        </v-card-title>

        <v-divider class="my-2" />

        <v-card-text class="text-body-2">
          Masa aktif sesi Anda telah habis. Silakan <strong>masuk kembali</strong> untuk
          melanjutkan. <br /><br />
          Anda akan diarahkan ke halaman login dalam
          <strong>{{ countdown }}</strong> detik.
        </v-card-text>

        <v-divider class="my-2" />

        <v-card-actions class="justify-end">
          <v-btn color="red darken-2 text-sm pa-5" size="small" dark rounded @click="confirmLogout">
            <v-icon left>mdi-logout</v-icon>
            Logout Sekarang
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "./components/Loader.vue";
import Navbar from "./components/Navbar.vue";
import Navigation from "./components/Navigation.vue";
import TitleBar from "./components/TitleBar.vue";
import Toast from "./components/Toast.vue";
import { EventBus } from "./eventBus";
export default {
  name: "App",
  components: {
    Navigation,
    TitleBar,
    Navbar,
    Loader,
    Toast,
  },
  data() {
    return {
      countdown: 10,
      countdownTimer: null,
      prompt: false,
      updateDialog: false,
    };
  },

  computed: {
    ...mapGetters(["dialogLogout"]),
  },

  watch: {
    dialogLogout(val) {
      if (val) {
        this.startCountdown();
      } else {
        this.resetCountdown();
      }
    },
  },

  methods: {
    // EVENT LOGOUT
    ...mapActions(["logout"]),
    async doLogout() {
      await deleteData("user_data", "user");
      this.logout();

      if (this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
    startCountdown() {
      this.countdown = 10;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.confirmLogout();
        }
      }, 1000);
    },

    resetCountdown() {
      clearInterval(this.countdownTimer);
      this.countdown = 10;
    },

    confirmLogout() {
      this.resetCountdown();
      this.$store.commit("SET_DIALOG_LOGOUT", false);
      this.logout();
      this.$router.replace("/login");
    },
    // END EVENT LOGOUT
    async update() {
      this.prompt = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
    reloadPage() {
      window.location.reload();
    },
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true;
      });
    }
    EventBus.$on("show-update-dialog", () => {
      if (this.$route.name !== "Login" && this.$store.state.isAuthenticated) {
        this.updateDialog = true;
        console.log("updateDialog diubah menjadi:", this.updateDialog);
      }
    });
  },
};
</script>

<style lang="scss">
// #app {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
//   margin-top: 60px;
// }

.update-dialog {
  position: fixed;
  left: 50%;
  bottom: 64px;
  transform: translateX(-50%);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 12px;
  max-width: 576px;
  color: white;
  background-color: #2c3e50;
  text-align: left;

  &__actions {
    display: flex;
    margin-top: 8px;
  }

  &__button {
    margin-right: 8px;

    &--confirm {
      margin-left: auto;
    }
  }
}
</style>
